import React from "react";
import featuresData from "../../features";
import "./Features.css";

function Features() {
  const [selectedFeature, setSelectedFeature] = React.useState(featuresData[0]);

  const features = featuresData.map((feature, i) => {
    return (
      <div key={i} className="w-3/5">
        <h3
          className="text-lg lg:text-3xl hover:cursor-pointer font-medium mb-2 underline-hover-animation inline-block"
          onClick={() => setSelectedFeature(featuresData[i])}
        >
          {feature.featureName}
        </h3>
        {featuresData[i] === selectedFeature && (
          <>
            <p className="text-md lg:text-lg">{feature.desc}</p>
            {/* Mobile images - show below description on small screens */}
            <div className="md:hidden mt-4">
              {selectedFeature.imgFiles.map((imgFile, index) => (
                <img
                  key={index}
                  id={imgFile.split(".")[0]}
                  className={`feature-img feature-img-${index} mb-4`}
                  src={require(`../../images/${imgFile}`)}
                  alt={`Discord Embed of Feature`}
                  loading="lazy"
                />
              ))}
            </div>
          </>
        )}
        <div className="my-4 border-b border-black md:w-[250px] lg:w-[450px]"></div>
      </div>
    );
  });

  return (
    <section
      id="features"
      className="py-16 lg:py-20 bg-[var(--blue)] border-x-2 border-black border-dashed"
    >
      <div className="flex flex-col md:flex-row w-4/5 lg:4/5 mx-auto">
        <div className="flex flex-col md:w-1/2">
          <h2 className="text-4xl lg:text-7xl mb-5">Features</h2>
          {features}
        </div>

        {/* Desktop images - show on right side for medium screens and up */}
        <div
          className={`hidden md:block md:w-1/2 ${selectedFeature.featureName.replace(
            " ",
            "-"
          )}`}
        >
          {selectedFeature.imgFiles.map((imgFile, index) => (
            <img
              key={index}
              id={imgFile.split(".")[0]}
              className={`hidden md:block feature-img feature-img-${index}`}
              src={require(`../../images/${imgFile}`)}
              alt={`Discord Embed of Feature`}
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
